/**
 * RDT regulation types from the Driving Times Service (DTS).
 *
 * @readonly
 * @enum {string}
 */
export const RdtRegulationTypes = Object.freeze({
    ARV1_2011: 'ARV1_2011',
    EU_561: 'EU_561',
    FPERSV: 'FPERSV'
})
